import React from 'react';
import { Link } from 'react-router-dom';
import PageContainer from '../../components/common/PageContainer';
import PageSection from '../../components/common/PageSection';

const AdminApplicationPending: React.FC = () => {
  return (
    <PageContainer>
      <PageSection title="Application Submitted" emoji="✅">
        <div className="text-center">
          <p className="text-lg text-gray-700 mb-4">
            Thank you for submitting your application.
          </p>
          <p className="text-gray-600 mb-8">
            Our team will review your credentials and you will be notified via email once a decision has been made. This typically takes 2-3 business days.
          </p>
          <Link
            to="/settings"
            className="bg-indigo-600 hover:bg-indigo-700 text-white font-bold py-2 px-4 rounded transition-colors duration-200"
          >
            Return to Settings
          </Link>
        </div>
      </PageSection>
    </PageContainer>
  );
};

export default AdminApplicationPending; 